export const DEFAULT_LOCALE = 'en';

export const LOCALE_REGISTRY = Object.freeze({
	[DEFAULT_LOCALE]: {
		label: 'English',
	},
	de: {
		label: 'Deutsch',
	},
	es: {
		label: 'Español',
	},
	fr: {
		label: 'Français',
	},
	it: {
		label: 'Italiano',
	},
	ko: {
		label: '한국어',
	},
	nl: {
		label: 'Nederlands',
	},
	ja: {
		label: '日本語',
	},
	pl: {
		label: 'Polski',
	},
	br: {
		label: 'Português',
	},
	ru: {
		label: 'русский',
	},
	zh: {
		label: '中文',
	},
	xx: {
		label: 'Pseudo-Translation',
	},
	zz: {
		label: 'Instrumented Language Pack',
	},
} as const);

export const LOCALES = Object.keys(LOCALE_REGISTRY);

export const ATLASSIAN_SUPPORT_CENTER_SUPPORTED_LOCALES = ['ja'];
